<template>
  <div v-loading.fullscreen.lock="loading" class="loginpage">
    <div class="loginbox">
      <div class="l-left">
        <div>
          云南省建设工程<br />
          材料及设备 <br />
          信息登记
        </div>
      </div>
      <div class="l-right">
        <div class="titleContoller">
          企业用户注册
        </div>
        <div class="l-inputs marginTop20">
          <div class="l-input">
            <input
              v-model="company_name"
              autocomplete="new-password"
              type="text"
              placeholder="请填写企业名称"
            />
          </div>
          <div class="l-input mt-30">
            <input v-model="mobile" type="text" placeholder="请输入手机号" />
          </div>
          <div class="l-input code mt-30">
            <input v-model="code" type="text" placeholder="短信验证码" />
            <div :class="senDisable ? 'sendbtn2' : 'sendbtn'" @click="send">
              {{ sendtxt }}
            </div>
          </div>
          <div class="l-input mt-30">
            <input
              v-model="username"
              autocomplete="new-password"
              type="text"
              placeholder="请设置统一社会信用代码"
            />
          </div>
          <div class="l-input mt-30">
            <input
              v-model="password"
              autocomplete="new-password"
              type="password"
              placeholder="请设置登录密码"
            />
          </div>
          <div class="l-input mt-30">
            <input
              v-model="confirmpwd"
              type="password"
              placeholder="请确认登录密码"
            />
          </div>
          <p v-show="error1" class="errtip">{{ error1 }}</p>
          <div
            :class="
              username && password && code && mobile && confirmpwd
                ? 'loginbtn mt-40 loging'
                : 'loginbtn mt-40'
            "
            @click="login"
          >
            注 册
          </div>
        </div>
        <div class="other mt-20">
          <!-- <el-checkbox v-model="agree">
            已阅读并同意<span @click="open">《用户协议》</span>
          </el-checkbox> -->
          <div class="o-right" @click="register">
            账号登录
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Api from "../../plugins/axios.js";
export default {
  data() {
    return {
      phone: "",
      // code: '',
      msg: "",
      name: "",
      // checkcode: '',
      error1: "",
      beginClientX: 0, //  距离屏幕左端距离
      mouseMoveStata: false, //  触发拖动状态判断
      maxwidth: 385, //  拖动最大宽度，根据滑块宽度计算出来的
      confirmWords: "请按住滑块，拖动到最右边",
      confirmSuccess: false, //  验证成功判断
      loading: false,
      // ~~~~~~
      countdown: 120, // 验证码倒计时
      senDisable: 0, // 按钮禁用状态
      sendtxt: "发送验证码", // 手机验证码发送文字
      sendStatus: 0, // 手机验证码发送状态
      username: "",
      password: "",
      code: "",
      mobile: "",
      confirmpwd: "",
      agree: false,
      company_name: ""
    };
  },
  mounted() {},
  methods: {
    // 打开协议对话框
    async open() {
      this.loading = true;
      const re = await Api.agreement();
      this.loading = false;
      this.$alert(re.content, re.title, {
        customClass: "xieyiController",
        closeOnClickModal: true,
        dangerouslyUseHTMLString: true
      });
    },
    // uploadcanvas(e) {
    //   this.checkcode = e
    // },
    focus() {
      this.error1 = "";
    },
    async send() {
      if (this.mobile) {
        if (this.sendStatus === 0) {
          // 在手机号存在并且短信能发送的状态下，发送短信要加载loading动画
          this.loading = true;
          try {
            await Api.sendMsg(
              this.mobile.replace(/(^\s*)|(\s*$)/g, ""),
              "register"
            );
            // 定时器启动
            const timer = setInterval(() => {
              if (this.countdown === 0) {
                clearInterval(timer);
                this.senDisable = 0;
                this.sendtxt = "发送验证码";
                this.countdown = 120;
                this.sendStatus = 0;
              } else {
                this.senDisable = 1;
                this.sendtxt = "再次发送(" + this.countdown + "s)";
                this.countdown--;
                this.sendStatus = 1;
              }
            }, 1000);
            this.loading = false;
            this.$msgbox({
              title: "提示",
              type: "success",
              message: "发送成功，请查收！"
            });
          } catch (error) {
            this.loading = false;
            this.$msgbox({ title: "提示", type: "error", message: error });
          }
        } else {
          this.$msgbox({ title: "提示", type: "error", message: "请稍候！" });
        }
      } else {
        this.$msgbox({
          title: "提示",
          type: "error",
          message: "请先输入手机号"
        });
      }
    },
    async login() {
      if (
        this.username &&
        this.password &&
        this.code &&
        this.mobile &&
        this.confirmpwd
      ) {
        this.loading = true;
        try {
          const re = await Api.register(
            this.username,
            this.password,
            this.code,
            this.mobile,
            this.confirmpwd,
            this.$store.state.wechatLoginState,
            this.company_name
          );
          localStorage.setItem("userinfo", JSON.stringify(re.userinfo));
          this.$store.commit("SET_USERINFO", re.userinfo);
          localStorage.setItem("userid", re.userinfo.id);
          this.$store.commit("SET_USERID", re.userinfo.id);
          localStorage.setItem("token", re.userinfo.token);
          this.$store.commit("SET_TOKEN", re.userinfo.token);
          if (this.$store.state.wechatLoginState) {
            this.$msgbox({
              title: "提示",
              message: "绑定微信成功",
              type: "success"
            });
            this.$store.commit("setWechatLoginState", null);
          }
          this.$router.push({ name: "AgentInfo" });
        } catch (error) {
          this.error1 = error.toString();
        }
        this.loading = false;
      }
    },
    check() {
      if (!this.agree) {
        this.error1 = "请勾选“已阅读并同意《用户协议》”";
        return false;
      } else {
        this.error1 = "";
        return true;
      }
    },
    mousedownFn(e) {
      this.mouseMoveStata = true;
      this.beginClientX = e.clientX;
    },
    register() {
      this.$router.push("/login");
    }
  },
  head() {
    return {
      title: this.seo_title,
      meta: [
        {
          hid: "keywords",
          name: "keywords",
          content: this.seo_keywords
        },
        {
          hid: "description",
          name: "description",
          content: this.seo_desc
        }
      ]
    };
  }
};
</script>
<style>
.xieyiController {
  width: 800px;
  max-height: 600px;
  overflow: auto;
}
</style>
<style lang="stylus" scoped>
// 下面是公共样式搬迁过来的代码
input {
  border: none;
  /* outline: none; */
  padding: 0 10px;
  box-sizing: border-box;
}
.sendbtn, .sendbtn2 {
  width: 90px;
  height: 50px;
  border-radius: 2px;
  font-size: 12px;
  line-height: 50px;
  text-align: center;
  background: #0082a4;
  color: #fff;
  cursor: pointer;
}
.ml-10 {
  margin-left: 10px;
}

.ml-20 {
  margin-left: 20px;
}

.ml-40 {
  margin-left: 40px;
}

.ml-60 {
  margin-left: 60px;
}

.ml-80 {
  margin-left: 80px;
}

.mr-20 {
  margin-right: 20px;
}

.mr-40 {
  margin-right: 40px;
}

.mt-10 {
  margin-top: 10px;
}

.mt-16 {
  margin-top: 16px;
}

.mt-20 {
  margin-top: 20px;
}

.mt-30 {
  margin-top: 30px;
}

.mt-40 {
  margin-top: 40px;
}

.mb-10 {
  margin-bottom: 10px;
}

.mb-20 {
  margin-bottom: 20px;
}

.mb-30 {
  margin-bottom: 30px;
}

.mb-50 {
  margin-bottom: 50px;
}
// 上面是公共样式搬迁过来的代码
.loginpage
  display flex
  flex-direction column
  align-items center
  justify-content center
  width 100%
  height calc(100vh - 150px)
  min-height calc(100vh - 150px)
.loginbox
  display flex
  justify-content center
  width 640px
  min-height 470px
  box-shadow 0px 0px 12px rgba(0,0,0,0.15)
  background #fff
.l-left
  text-align center;
  display flex
  flex-direction column
  align-items center
  justify-content center
  width 280px
  border-radius 4px 0 0 4px
  background url(../../assets/coverBg.png) no-repeat
  background-size cover
  background-position 76% 0%
  font-size:24px;
  font-weight:600;
  line-height:40px;
  color:rgba(255,255,255,1);
  opacity:1;
  p
    margin-top 16px
.l-right
  width 450px
  padding 26px 40px 26px 20px
  box-sizing borer-box
  border-radius 0 4px 4px 0
  .titleContoller
    text-align center
    font-size:26px;
    font-weight:600;
    color:rgba(0,130,164,1);
    opacity:1;
  input
    width 100%
    height 40px
    border-radius 2px
    background #f7f7f7
  input:focus
    outline #666666 auto 1px
.code
  display flex
  justify-content space-between
  .codebox
    width 90px
  input
    width calc(100% - 100px)
.l-inputs
  position relative
.errtip
  position absolute
  bottom 65px
  left 0
  font-size 12px
  color red
.loginbtn
  width 100%
  height 50px
  box-shadow 0px 3px 6px rgba(0,0,0,0.16)
  border-radius 2px
  font-size 18px
  text-align center
  line-height 50px
  background #9A9A9A
  color #fff
.loginbtn.loging
  background #0082a4 !important
  cursor pointer
.loginbtn.loging:hover
  background #0082a4 !important
.other
  display flex
  align-items center
  justify-content space-between
  font-size 14px
  .o-right
    color #666
    cursor pointer
  .o-right:hover
    color #0082a4
.drag
  position relative
  width 100%
  height 50px
  border-radius 2px
  font-size 14px
  line-height 50px
  text-align center
  background #F7F7F7
  color #999
.handler
  border-radius 2px
  position absolute
  top 0
  left 0
  width 60px
  height 50px
  border 1px #ccc solid
  box-sizing border-box
  cursor move
.handler_bg
  background #fff url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NTEyNTVEMURGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NTEyNTVEMUNGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo2MTc5NzNmZS02OTQxLTQyOTYtYTIwNi02NDI2YTNkOWU5YmUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+YiRG4AAAALFJREFUeNpi/P//PwMlgImBQkA9A+bOnfsIiBOxKcInh+yCaCDuByoswaIOpxwjciACFegBqZ1AvBSIS5OTk/8TkmNEjwWgQiUgtQuIjwAxUF3yX3xyGIEIFLwHpKyAWB+I1xGSwxULIGf9A7mQkBwTlhBXAFLHgPgqEAcTkmNCU6AL9d8WII4HOvk3ITkWJAXWUMlOoGQHmsE45ViQ2KuBuASoYC4Wf+OUYxz6mQkgwAAN9mIrUReCXgAAAABJRU5ErkJggg==") no-repeat center
.handler_ok_bg
  background #fff url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NDlBRDI3NjVGMkQ2MTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NDlBRDI3NjRGMkQ2MTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDphNWEzMWNhMC1hYmViLTQxNWEtYTEwZS04Y2U5NzRlN2Q4YTEiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+k+sHwwAAASZJREFUeNpi/P//PwMyKD8uZw+kUoDYEYgloMIvgHg/EM/ptHx0EFk9I8wAoEZ+IDUPiIMY8IN1QJwENOgj3ACo5gNAbMBAHLgAxA4gQ5igAnNJ0MwAVTsX7IKyY7L2UNuJAf+AmAmJ78AEDTBiwGYg5gbifCSxFCZoaBMCy4A4GOjnH0D6DpK4IxNSVIHAfSDOAeLraJrjgJp/AwPbHMhejiQnwYRmUzNQ4VQgDQqXK0ia/0I17wJiPmQNTNBEAgMlQIWiQA2vgWw7QppBekGxsAjIiEUSBNnsBDWEAY9mEFgMMgBk00E0iZtA7AHEctDQ58MRuA6wlLgGFMoMpIG1QFeGwAIxGZo8GUhIysmwQGSAZgwHaEZhICIzOaBkJkqyM0CAAQDGx279Jf50AAAAAABJRU5ErkJggg==") no-repeat center
.drag_bg
  width 0
  height 50px
  border-radius 2px
  background #0082a4
.drag_text
  position absolute
  top 0
  width 100%
  -moz-user-select none
  -webkit-user-select none
  user-select none
  -o-user-select none
  -ms-user-select none
.sendbtn, .sendbtn2
  height 40px
  line-height: 40px;
</style>
